export class UtilHelper {
    static clone(model: any) {
        return $.extend(true, {}, model);
    }

    static cloneList(list: any) {
        return $.extend(true, [], list);
    }

    static uniqBy(arr: any, predicate: string) {
        const cb = (o: any) => o[predicate];

        return [...arr.reduce((map: any, item: any) => {
            const key = cb(item);

            map.has(key) || map.set(key, item);

            return map;
        }, new Map()).values()];
    };

    static activateFilters(options: Array<Object>): void;
    static activateFilters(options: Array<Object>, ignore: number): void;

    static activateFilters(options: Array<Object>, ignore?: number) {
        const filterMenu = $("a.nav-link.filter").parents("li");
        const activeCount = options.filter((m: Object) => m).length;
        const isApply = typeof ignore === "number" ? (activeCount - ignore) > 0 : activeCount > 0;
        isApply ? filterMenu.addClass("active") : filterMenu.removeClass("active");
    }

    static activateFiltersByObject(options: any, ignore?: number) {
        const filterMenu = $("a.nav-link.filter").parents("li");
        const activeCount = Object.keys(options).map((key: string) => options[key]).filter((m: Object) => m).length;
        const isApply = typeof ignore === "number" ? (activeCount - ignore) > 0 : activeCount > 0;
        isApply ? filterMenu.addClass("active") : filterMenu.removeClass("active");
    }

    static hideFilters() {
        $("a.nav-link.filter").parents("li").removeClass("active");
        $("#collapseExample").removeClass("show");
    }

    static downloadFile(blob: Blob, fileName: string) {
        const newBlob = new Blob([blob], { type: blob.type });

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob);
            return;
        }

        const data = window.URL.createObjectURL(newBlob);
        const link = document.createElement("a");
        link.href = data;
        link.download = fileName;
        link.click();
        setTimeout(() => {
            window.URL.revokeObjectURL(data);
        }, 100);
    }
}